<template>
  <div class="bb-contact-company">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-contact-company-header"
         :class="{'bb-contact-company-header_edit': editable}">
      <div class="bb-contact-company-header__title">{{titleCard}}</div>
      <div class="bb-contact-company-header-toolbar" v-if="!editable">
        <i class="icon-edit bb-icon bb-icon_accent" @click.stop="editable = true"/>
        <i class="icon-trash-1 bb-icon bb-icon_red" @click.stop="openDoubleDelete = true"/>
      </div>
    </div>
    <VuePerfectScrollbar class="bb-contact-company-body"
                         :class="{'bb-contact-company-body_edit': editable}"
                         ref="bbContactCompanyScroll">
      <template v-if="editable">
        <div class="bb-contact-company-body-item"
             :class="{'bb-contact-company-body-item_border': inputGroup.border}"
             v-for="(inputGroup, index) in inputs"
             :key="inputGroup.id">
          <Form :inputs-list="inputGroup.data"
                :defaultModel="currentCompanyFormat"
                :autofocus="index === 0"
                :target="{index: index, id: inputGroup.id}"
                :errors="errors"
                :grid="gridForm"
                @loader="setLoader"
                :save="validateDataForm"
                @error="scrollToError"
                @change="getFormResult"/>
        </div>
        <div class="bb-contact-company-body__title">{{financesTitle}}</div>
        <div class="bb-contact-company-body-item"
             :class="{'bb-contact-company-body-item_border': inputGroup.border}"
             v-for="(inputGroup, index) in inputsFinances"
             :key="inputGroup.id">
          <Form :inputs-list="inputGroup.data"
                :defaultModel="currentCompanyFormat"
                :autofocus="false"
                :target="{index: index, id: inputGroup.id}"
                :errors="errors"
                :grid="gridForm"
                :save="validateDataForm"
                @error="scrollToError"
                @change="getFormResult"/>
        </div>
        <div class="bb-contact-company-body__title">{{renewalTitle}}</div>
        <div class="bb-contact-company-body-item"
             :class="{'bb-contact-company-body-item_border': inputGroup.border}"
             v-for="(inputGroup, index) in inputsRenewal"
             :key="inputGroup.id">
          <Form :inputs-list="inputGroup.data"
                :defaultModel="currentCompanyFormat"
                :autofocus="false"
                :target="{index: index, id: inputGroup.id}"
                :errors="errors"
                :grid="gridForm"
                :save="validateDataForm"
                @error="scrollToError"
                @change="getFormResult"/>
        </div>
      </template>
      <div v-else>
        <div class="bb-contact-company-body-company">
          <i class="icon-picture bb-contact-company-body-company__stamp"
             v-if="currentCompany.uploadFile"
             @click="openFile(currentCompanyFormat.uploadFile)"/>
          <div class="bb-contact-company-body-company__name">{{currentCompany.name || ''}}</div>
        </div>
        <ContactCompanyForm @loader="setLoader" :company="currentCompanyFormat" :inputs="mainInputs"/>
        <div class="bb-contact-company-body__title bb-contact-company-body__title_desc" v-if="displayBanksSection">
          {{financesTitle}}
        </div>
        <ContactCompanyForm :company="currentCompanyFormat" :inputs="financesInputs"/>
        <div class="bb-contact-company-body__title bb-contact-company-body__title_desc" v-if="displayFinancesSection">
          {{renewalTitle}}
        </div>
        <ContactCompanyForm :company="currentCompanyFormat" :inputs="renewalInput"/>
      </div>
    </VuePerfectScrollbar>
    <div class="bb-contact-company-footer">
      <ButtonsEdit v-if="editable"
                   styleBtn="clientForm"
                   @edit="validateDataForm()"
                   @delete="closeForm()"
                   no-pop-up="false"
                   btn-right-text="CANCEL"
                   :btn-left-text="isNewCompany ? 'ADD' : 'SAVE'"
                   left-if="true"
      />
    </div>
    <transition name="fade">
      <DoubleDelete v-if="openDoubleDelete"
                    :id="companyId"
                    :title="currentCompany.name || 'Company'"
                    @close="openDoubleDelete = false"
                    @delete="deleteCompany"/>
    </transition>
  </div>
</template>

<script>
import {
  contactsCompanyInputs,
  contactCompanyInputsRenewal,
  contactsCompanyInputsFinances,
  allInputs,
  financesInputs,
  renewalInputs
} from '@/constants/Forms/contactCompanyForm'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import DoubleDelete from '@/components/Main/DoubleDelete/DoubleDelete'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Form from '@/components/Main/Form/Form'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import checkFieldUpdate from '@/mixin/checkFieldUpdate'
import {cloneDeep, forEach, filter, get, set, some, isEmpty, find, findIndex, compact} from 'lodash'
import ContactCompanyApi from '@/api/ContactCompanies/api'
import ContactsLicenseApi from '@/api/ContactsLicense/api'
import ContactCompanyForm
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyCard/ContactCompanyForm'
import UploadFileApi from '@/api/UploadFile/api'
import {statusCompany, visaQuote} from '@/constants/contactCompany'
import personalBanks from '@/constants/personalBanks'
import placesOfRegistration from '@/constants/placesOfRegistartion'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'

export default {
  name: 'ContactCompanyCard',
  components: {
    ContactCompanyForm,
    Form,
    DoubleDelete,
    VuePerfectScrollbar,
    ButtonsEdit,
    LoaderFly
  },
  mixins: [checkFieldUpdate],
  data () {
    return {
      mainInputs: allInputs,
      financesInputs: financesInputs,
      renewalInput: renewalInputs,
      inputs: contactsCompanyInputs,
      inputsFinances: contactsCompanyInputsFinances,
      inputsRenewal: contactCompanyInputsRenewal,
      editable: false,
      openDoubleDelete: false,
      company: {},
      errors: {},
      gridForm: {
        columns: 'auto',
        rows: 'repeat(auto-fil, auto)',
        gap: '10px'
      },
      currentCompany: {},
      currentCompanyFormat: {},
      loaderRun: false,
      positionErrors: [],
      licenseCounter: 0,
      financesTitle: 'Corporate Bank Accounts',
      renewalTitle: 'Renewal Fees',
      crypt: true,
      files: {}
    }
  },
  computed: {
    allInputs () {
      const allInputs = []
      this.inputs.concat(this.inputsFinances).forEach(form => allInputs.push(...form.data))
      return allInputs
    },
    isNewCompany () {
      return this.$route.params.company === 'new'
    },
    companyName () {
      const defaultName = this.isNewCompany ? 'Add a company' : this.currentCompany.name
      return this.company.name || defaultName
    },
    titleCard () {
      return this.editable ? this.companyName : 'Company Card'
    },
    contactId () {
      return this.$route.params.id
    },
    companyId () {
      return this.$route.params.company
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    displayBanksSection () {
      const value = get(this.currentCompany, 'banks', [])
      return value.length > 0
    },
    displayFinancesSection () {
      const financesModels = ['bbRenewal', 'bbAdmin', 'govtRenewalFee', 'eChannelRenewal']
      const length = financesModels.map(item => get(this.currentCompany, item, ''))
      return length.some(item => item)
    },
    clientCompanies: {
      get () {
        return this.$store.getters.clientCompanies
      },
      set (data) {
        this.$store.dispatch('setClientCompanies', data)
      }
    }
  },
  methods: {
    setLoader (value) {
      this.loaderRun = value
    },
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file)
    },
    getFile (file) {
      this.loaderRun = true
      UploadFileApi.getFile(file.id, this.crypt)
        .then((resp) => {
          this.openForm = true
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    closeForm () {
      this.editable = false
      if (this.isNewCompany) {
        this.$router.push({name: 'ContactCard', params: {id: this.contactId}})
      }
    },
    sendForm () {
      const result = this.generateCompanyBody()
      if (this.isNewCompany) {
        this.createCompany(result, true)
        return
      }
      this.licenseCounter = 0
      const licenses = filter(this.company.license, item => item.licenseNo || item.licenseDate)
      const length = licenses.length
      const oldCompany = find(this.clientCompanies, {id: this.companyId})
      if (!this.checkedUpdateFiles(result, oldCompany) && !this.isNewCompany) return
      const callback = this.isNewCompany ? this.createCompany : this.updateCompany
      licenses.forEach(license => {
        if (license.id && !this.checkedUpdateLicenses(license)) {
          return
        }
        this.updateLicense({license, result, callback, length})
      })
    },
    checkedUpdateLicenses (license) {
      const currentCompany = find(this.clientCompanies, {id: this.companyId})
      const oldLicenses = get(currentCompany, 'license', [])
      const oldCurrentLicense = find(oldLicenses, {id: license.id})
      const options = {
        newCompany: license,
        oldCompany: oldCurrentLicense,
        fieldDate: 'licenseDate',
        fieldFile: 'uploadFile'
      }
      const result = this.checkFieldUpdate(options)
      if (!result) {
        const errors = {}
        set(errors, 'licenseNo', 'Need to upload a file')
        this.errors = errors
      }
      return result
    },
    updateLicense ({license, result, callback, length}) {
      license.client = this.contactId
      license.clientCompany = this.companyId
      license.user = this.userInfo.id
      delete license.expireStatus
      if (license.uploadFile) {
        const fileId = typeof license.uploadFile === 'string' ? license.uploadFile : license.uploadFile.id
        license.uploadFile = fileId
      } else {
        delete license.uploadFile
      }
      const request = license.id ? ContactsLicenseApi.updateContactLicense : ContactsLicenseApi.createContactLicense
      request(license)
        .then((resp) => {
          this.licenseCounter++
          result.license.push(resp.data.id)
          if (this.licenseCounter === length) {
            callback(result)
          }
        })
        .catch((err) => {
          this.licenseCounter++
          if (this.licenseCounter === length) {
            callback(result)
          }
          console.error(err)
        })
    },
    checkedUpdateFiles (newCompany, oldCompany) {
      const estCardFields = {
        fieldDate: 'estCard.estCardDate',
        fieldFile: 'estCard.uploadFile',
        model: 'estCard.uploadFile'
      }
      const eChannelFields = {
        fieldDate: 'eChannel.date',
        fieldFile: 'eChannel.uploadFile',
        model: 'eChannel.uploadFile'
      }
      const officeFields = {
        fieldDate: 'officeAddress.leaseExp',
        fieldFile: 'officeAddress.uploadFile',
        model: 'officeAddress.uploadFile'
      }
      const allFields = [estCardFields, eChannelFields, officeFields]
      const result = allFields.map(item => this.checkFieldUpdate({newCompany, oldCompany, ...item}))
      const errorIndex = result.indexOf(false)
      if (errorIndex !== -1) {
        const errors = {}
        set(errors, allFields[errorIndex].model, 'Need to upload a file')
        this.errors = errors
      }
      return result.every(item => item)
    },
    updateCompany (company) {
      company.id = this.companyId
      ContactCompanyApi.updateContactCompany(company)
        .then((resp) => {
          resp.data.uploadFile = this.company.uploadFile
          this.currentCompany = resp.data
          this.editable = false
          const index = findIndex(this.clientCompanies, {id: resp.data.id})
          if (index !== -1) this.clientCompanies.splice(index, 1, resp.data)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    createCompany (company, createLicenses) {
      ContactCompanyApi.createContactCompany(company)
        .then((resp) => {
          this.$router.push({name: 'CompanyContact', params: {company: resp.data.id}})
          this.currentCompany = resp.data
          this.editable = false
          this.clientCompanies.push(resp.data)
          if (createLicenses) this.sendForm()
        })
        .catch((e) => {
          console.error(e)
        })
    },
    removeEmpty (company, val, key) {
      const array = filter(val, item => typeof item === 'object' ? !isEmpty(item) : item)
      if (Array.isArray(val) && val.length > 0 && array.length === 0) {
        delete company[key]
      } else if (Array.isArray(val) && val.length === 0) {
        delete company[key]
      } else if (Array.isArray(val) && key !== 'shareholder' && key !== 'director' && key !== 'banks') {
        company[key] = array
      }
    },
    setFiles (company, format) {
      const files = [
        {key: 'eChannel', file: 'uploadFile'},
        {key: 'estCard', file: 'uploadFile'},
        {key: 'officeAddress', file: 'uploadFile'}
      ]
      files.forEach(prop => {
        const filePath = prop.key + '.' + prop.file
        const filePathId = format ? filePath : filePath + '.id'
        const fileId = get(company, filePathId, '')
        if (fileId) {
          const setPath = format ? filePath + '.id' : filePath
          set(company, setPath, fileId)
        } else {
          delete company[prop.key][prop.file]
        }
      })
      company.license.forEach((license, index) => {
        if (!license || !license.uploadFile) return
        const filePathId = format ? 'uploadFile' : 'uploadFile.id'
        const fileId = get(license, filePathId, '')
        const setPath = format ? ['uploadFile', 'id'] : ['uploadFile']
        set(license, setPath, fileId)
      })
    },
    generateCompanyBody () {
      const company = cloneDeep(this.company)
      this.setFiles(company)
      forEach(company, (val, key) => {
        if (key === 'status' || key === 'visaQuote') {
          set(company, key, val.id)
        } else if (key === 'shareholder') {
          const shareholder = val.map(item => item.shareholderName || '')
          set(company, key, compact(shareholder))
        } else if (key === 'director') {
          const director = val.map(item => item.directorName || '')
          set(company, key, compact(director))
        } else if (key === 'uploadFile') {
          val.id ? set(company, key, val.id) : delete company[key]
        } else if (key === 'formedIn') {
          set(company, key, val.id)
        } else if (key === 'banks') {
          const banks = val.map(item => {
            const isObject = typeof item.bankName === 'object'
            const bankName = isObject ? get(item, 'bankName.id', 0) : (item.bankName || 0)
            return {bankNo: item.bankNo, bankName: bankName}
          })
          if (banks.length > 1) {
            const filterBanks = filter(banks, item => item.bankName)
            set(company, key, compact(filterBanks))
          } else {
            set(company, key, compact(banks))
          }
        }
        company.license = []
        this.removeEmpty(company, val, key)
      })
      company.client = this.contactId
      return company
    },
    deleteCompany (id) {
      this.$router.push({name: 'ContactCard', params: {id: this.contactId}})
      this.openDoubleDelete = false
      ContactCompanyApi.deleteContactCompany(id)
        .then((resp) => {
          this.editable = false
        })
        .catch((e) => {
          console.error(e)
        })
    },
    setDefaultErrors () {
      this.errors = {}
      const requireInputs = filter(this.allInputs, 'require')
      requireInputs.forEach(input => set(this.errors, input.model, false))
    },
    checkRequired () {
      const errors = {}
      this.allInputs.forEach(input => {
        if (input.require) {
          const groupValue = get(this.company, [input.group, input.counter, input.model])
          const aloneValue = get(this.company, input.model)
          const value = input.group ? groupValue : aloneValue
          const error = value ? false : 'mandatory field'
          set(errors, input.model, error)
        }
      })
      this.errors = errors
    },
    validateDataForm () {
      this.checkRequired()
      const hasError = some(this.errors, item => item !== false)
      if (!hasError) this.sendForm()
    },
    getFormResult (form) {
      this.setDefaultErrors()
      if (form.name) {
        this.$set(this.company, 'name', form.name)
      }
      Object.assign(this.company, form)
    },
    scrollToError (node) {
      const bodyForm = get(this.$refs, 'bbContactCompanyScroll.$el', {})
      if (!node || !bodyForm) return
      const parentTop = get(node, 'parentNode.offsetTop', 0)
      const scrollTo = node.offsetTop + parentTop - 73
      this.positionErrors.push(scrollTo)
      setTimeout(() => {
        bodyForm.scrollTop = Math.min(this.positionErrors)
      }, 150)
      setTimeout(() => {
        this.positionErrors = []
      }, 300)
    },
    getCompany () {
      if (this.isNewCompany) {
        this.currentCompany = {}
        this.currentCompanyFormat = {}
        this.company = {}
        setTimeout(() => {
          this.editable = true
        }, 0)
        return
      }
      this.loaderRun = true
      ContactCompanyApi.getContactCompanyById(this.companyId)
        .then((resp) => {
          this.loaderRun = false
          this.currentCompany = resp.data
          this.setCompanyInfo()
        })
        .catch((e) => {
          this.loaderRun = false
          console.error(e)
        })
    },
    setCompanyInfo () {
      if (!this.currentCompany.id) return
      this.currentCompanyFormat = cloneDeep(this.currentCompany)
      this.currentCompanyFormat.status = find(statusCompany, {id: this.currentCompany.status})
      this.currentCompanyFormat.visaQuote = find(visaQuote, {id: this.currentCompany.visaQuote})
      this.currentCompanyFormat.formedIn = find(placesOfRegistration, {id: +this.currentCompany.formedIn})
      const banks = this.currentCompany.banks.map(item => {
        const bankName = find(personalBanks, {id: +item.bankName})
        return {bankName: bankName, bankNo: item.bankNo}
      })
      set(this.currentCompanyFormat, 'banks', banks)
      const directors = this.currentCompany.director.map(item => { return {directorName: item} })
      set(this.currentCompanyFormat, 'director', directors)
      const shareholders = this.currentCompany.shareholder.map(item => { return {shareholderName: item} })
      set(this.currentCompanyFormat, 'shareholder', shareholders)
      const companyStamp = get(this.currentCompany, 'uploadFile', '')
      if (companyStamp && typeof companyStamp === 'string') {
        set(this.currentCompanyFormat, ['uploadFile', 'id'], companyStamp)
      }
      this.setFiles(this.currentCompanyFormat, true)
    }
  },
  watch: {
    isNewCompany (newVal) {
      this.editable = newVal
    },
    currentCompany () {
      this.setCompanyInfo()
    },
    companyId () {
      this.editable = false
      this.getCompany()
    }
  },
  mounted () {
    this.editable = this.isNewCompany
    this.getCompany()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-contact-company {
    @include global-font;
    display: grid;
    grid-template-rows: 36px 1fr auto;
    width: 370px;
    height: 100%;
    background: $color-white;
    border-radius: 5px;
    font-size: 12px;
    padding: 18px 0;

    &-header {
      padding: 0 20px 15px;
      border-bottom: 1px solid $color-wild-sand;
      font-weight: 600;
      font-size: 15px;
      line-height: 18px;
      color: $color-accent;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &_edit {
        justify-content: center;
        border-color: transparent;
        color: $color-black;
      }

      &-toolbar {
        display: grid;
        grid-template-columns: 25px 25px;
        grid-gap: 6px;
      }
    }

    &-body {
      height: calc(100vh - 168px);
      overflow: hidden;

      &_edit {
        height: calc(100vh - 230px);
      }

      &-company {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0 8px;
        color: $color-accent;
        min-height: 40px;

        &__stamp {
          margin-right: 14px;
          font-size: 18px;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px dashed $color-mercury;
          box-sizing: border-box;
          border-radius: 5px;
          cursor: pointer;
          transition: 0.3s;

          &:hover {
            color: $color-accent-hover;
          }
        }

        &__name {
          font-weight: bold;
          font-size: 14px;
          line-height: 17px;
          cursor: default;
        }
      }

      &__title {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        padding: 15px 25px 10px;
        border-top: 2px solid $color-wild-sand;
        margin-top: 15px;

        &_desc {
          padding: 3px 20px;
          border-color: transparent;
        }
      }

      &-item {
        margin: 0 25px 10px;

        &_border {
          padding: 10px;
          margin: 0 15px 10px;
          border: 1px dashed $color-mercury;
          box-sizing: border-box;
          border-radius: 5px;
        }
      }
    }

    &-footer {
      margin: auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyCard/ContactCompanyCard.vue